module.exports = "/_next/static/images/asia-c7a2681e2e3e16afe2652426cd753a73.svg";